module.exports = __webpack_public_path__ + "img/Gazprom_120X35.c06fd33d.png";